import api from '../../api'

export default {
  name: 'CompanyCard',
  data: () => {
    return {
      name: '',
      alias: '',
      email: '',
      telephone: '',
      address: '',
      bankName: '',
      unp: '',
      bankDetails: '',
      description: '',
      bik: '',
      actingDirector: '',
      actingDocument: '',
      realAddress: '',
      kpp: '',
      okato: '',
      okpo: '',
      ogrn: '',
      logo: '',
      stamp: ''
    }
  },
  methods: {
    updateCompanyInfo () {
      const customerInfo = {
        name: this.name,
        alias: this.alias,
        email: this.email,
        telephone: this.telephone,
        address: this.address,
        bank: this.bankName,
        UNP: this.unp,
        payment_account: this.bankDetails,
        description: this.description,
        bik: this.bik,
        acting_director: this.actingDirector,
        acting_document: this.actingDocument,
        real_address: this.realAddress,
        kpp: this.kpp,
        okato: this.okato,
        okpo: this.okpo,
        ogrn: this.ogrn,
        logo: this.logo,
        scan_stamp: this.stamp
      }
      api.post
        .updateCustomerInfo(
          this.$store.state.userInfo.customer.id,
          customerInfo
        )
        .then(() => {
          this.loadData()
          this.$notify({
            message: this.$t('settings.company_info_updated'),
            type: 'success'
          })
        })
        .catch(() => this.loadData())
    },
    loadData () {
      api.get
        .customerInfo(this.$store.state.userInfo.customer.id)
        .then(response => {
          const customer = response.data.data.customer
          this.name = customer.name || ''
          this.alias = customer.alias || ''
          this.unp = customer.UNP || ''
          this.address = customer.address || ''
          this.bankName = customer.bank || ''
          this.bankDetails = customer.payment_account || ''
          this.telephone = customer.telephone || ''
          this.email = customer.email || ''
          this.description = customer.description || ''
          this.bik = customer.bik || ''
          this.actingDirector = customer.acting_director || ''
          this.actingDocument = customer.acting_document || ''
          this.realAddress = customer.real_address || ''
          this.kpp = customer.kpp || ''
          this.okato = customer.okato || ''
          this.okpo = customer.okpo || ''
          this.ogrn = customer.ogrn || ''
          this.logo = customer.logo || ''
          this.stamp = customer.scan_stamp || ''
        })
    },
    handleLogo (e) {
      const selectedImage = e.target.files[0]
      const size = selectedImage.size && (selectedImage.size / Math.pow(1000, 2))

      // check file max size
      if (size > 1) {
        this.$notify({
          message: 'Превышен максимальный размер файла 1 мб',
          type: 'danger'
        })
        e.target.value = ''
        return
      }

      const onLoad = (e) => {
        this.logo = e.target.result
      }
      this.createBase64Image(selectedImage, onLoad)
    },
    handleStamp (e) {
      const selectedImage = e.target.files[0]
      const size = selectedImage.size && (selectedImage.size / Math.pow(1000, 2))

      // check file max size
      if (size > 1) {
        this.$notify({
          message: 'Превышен максимальный размер файла 1 мб',
          type: 'danger'
        })
        e.target.value = ''
        return
      }

      const onLoad = (e) => {
        this.stamp = e.target.result
      }
      this.createBase64Image(selectedImage, onLoad)
    },
    createBase64Image (file, onload) {
      const reader = new FileReader()

      reader.onload = onload

      reader.readAsDataURL(file)
    }
  },
  created () {
    this.loadData()
  }
}
